import { useEffect, useState } from "react";
import MuiHeader from "../../components/MuiHeader";
import MuiLoader from "../../components/MuiLoader";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Button,
  Box,
} from "@mui/material";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getAllEditRequests, updateStudentFeedback } from "./ECstudentEdit.api";
import { NewspaperRounded } from "@mui/icons-material";

const ECstudentEdit = () => {
  const [editStatus, setEditStatus] = useState("requested");
  const [allEditRequestData, setAllEditRequestData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [data, setData] = useState("");
  const statusOptions = [
    { value: "requested", text: "Requested" },
    { value: "approved", text: "Approved" },
    { value: "rejected", text: "Rejected" },
  ];

  const tableHeaders =
    editStatus === "requested"
      ? [
          "Sl no.",
          "Requested by",
          "Cluster",
          "School",
          "Name",
          "Requested Name",
          "Class",
          "Requested Class",
          "User Status",
          "New User Status",
          "Action",
        ]
      : [
          "Sl no.",
          "Requested by",
          "Cluster",
          "School",
          "Name",
          "Requested Name",
          "Class",
          "Requested Class",
          "User Status",
          "New User Status",
        ];

  const editStatusOnChange = (e) => {
    setEditStatus(e.target.value);
    setAllEditRequestData([]);
  };

  const fetchEditRequests = () => {
    setLoading(true);
    getAllEditRequests(editStatus)
      .then((res) => {
        if (res.status === 200) {
          setAllEditRequestData(res.data.data);
        } else {
          setAllEditRequestData([]);
          toast.info("No data could be found for the selected option!");
        }
      })
      .catch(() => {
        toast.error("Sorry, something went wrong. Please try again later!");
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchEditRequests();
  }, [editStatus, refresh]);

  const hadleAcceptRequest = (data) => {
    console.log("data received----------->", data);
    const body = {
      student_id: data.student_id,
      requestedStatus: "approved",
      student_name: data.student_name,
      class: data.class,
      whatsapp_user: data.whatsapp_user,
    };
    updateStudentFeedback(body)
      .then((res) => {
        console.log("res.status------------>", res);
        if (res.status === 200) {
          toast.success("Edit request approved successfully!");
          fetchEditRequests();
        } else {
          toast.error(
            "Sorry, couldn't update student data at the moment. Please try again later!"
          );
        }
      })
      .catch((error) => {
        console.error("The error while approving----->", error);
        toast.error("Sorry, Something went wrong ! Please try again later!");
      });
  };

  const hadleRejectRequest = (data) => {
    console.log("data received----------->", data);

    const body = {
      student_id: data.student_id,
      requestedStatus: "rejected",
      student_name: data.student_name,
      class: data.class,
      whatsapp_user: data.whatsapp_user,
    };
    updateStudentFeedback(body)
      .then((res) => {
        console.log("res.status------------>", res);
        if (res.status === 200) {
          toast.success("Request rejected successfully!");
          fetchEditRequests();
        } else {
          toast.error(
            "Sorry, couldn't update student data at the moment. Please try again later!"
          );
        }
      })
      .catch((error) => {
        console.error("The error while approving----->", error);
        toast.error("Sorry, Something went wrong ! Please try again later!");
      });
  };

  return (
    <div>
      <MuiHeader header="Student Edit Requests" />
      <div style={styles.containerDiv}>
        <FormControl style={styles.requestStatusDropdown} size="small">
          <InputLabel id="status-select-label">Request Status</InputLabel>
          <Select
            labelId="status-select-label"
            id="status-select"
            value={editStatus}
            onChange={editStatusOnChange}
            label="Request Status"
          >
            {statusOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      <div style={styles.tableContainer}>
        {loading ? (
          <MuiLoader open={loading} />
        ) : allEditRequestData?.length > 0 ? (
          <Table style={styles.table}>
            <TableHead>
              <TableRow>
                {tableHeaders?.map((header, index) => (
                  <TableCell key={index} style={styles.tableCell}>
                    {header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {allEditRequestData?.map((item, idx) => (
                <TableRow key={idx}>
                  <TableCell style={styles.tableCell}>{idx + 1}</TableCell>
                  <TableCell style={styles.tableCell}>
                    {item.consultantName}
                  </TableCell>
                  <TableCell style={styles.tableCell}>{item.cluster}</TableCell>
                  <TableCell style={styles.tableCell}>
                    {item.school_name}
                  </TableCell>
                  <TableCell style={styles.tableCell}>
                    {item.studentDetails.student_name}
                  </TableCell>
                  <TableCell style={styles.tableCell}>
                    {item.student_name}
                  </TableCell>
                  <TableCell style={styles.tableCell}>
                    {item.studentDetails.class}
                  </TableCell>
                  <TableCell style={styles.tableCell}>{item.class}</TableCell>
                  <TableCell style={styles.tableCell}>
                    {item.studentDetails.whatsapp_user ? "Yes" : "No"}
                  </TableCell>
                  <TableCell style={styles.tableCell}>
                    {item.whatsapp_user ? "Yes" : "No"}
                  </TableCell>
                  {editStatus === "requested" ? (
                    <TableCell style={styles.tableCell}>
                      <div style={styles.actionButtons}>
                        <Button onClick={() => hadleAcceptRequest(item)}>
                          <CheckRoundedIcon />
                        </Button>
                        <Button
                          onClick={() => hadleRejectRequest(item)}
                          style={{ color: "red" }}
                        >
                          <ClearRoundedIcon />
                        </Button>
                      </div>
                    </TableCell>
                  ) : null}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <Typography variant="body1" style={styles.noDataMessage}>
            No data available for the selected status.
          </Typography>
        )}
      </div>
      <ToastContainer />
    </div>
  );
};

export default ECstudentEdit;

const styles = {
  containerDiv: {
    marginTop: "2.5%",
    display: "flex",
    justifyContent: "flex-start",
  },
  requestStatusDropdown: {
    marginTop: "20px",
    width: "15%",
    marginLeft: "40px",
    marginBottom: "20px",
  },
  tableContainer: {
    marginTop: "20px",
    width: "95%",
    margin: "auto",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    overflowX: "auto",
  },
  tableCell: {
    textAlign: "center",
    fontSize: "14px",
    padding: "8px",
  },
  actionButtons: {
    display: "flex",
    justifyContent: "center",
    gap: "8px",
  },
  noDataMessage: {
    textAlign: "center",
    color: "#777",
    marginTop: "20px",
  },
};
